export default __webpack_public_path__ + "static/taskner-af0944be485b2705ca0d3d85451fa9b2.webp";